module.exports = __webpack_public_path__ + "img/camera.bbeb9489.svg";